import request from '@/utils/request';

export function queryAiNoticePage(data) {
  return request({
    url: '/ai/aiNotice/queryPage',
    method: 'post',
    data,
  });
}

export function getAiNoticeDetail(params) {
  return request({
    url: '/ai/aiNotice/detail',
    method: 'get',
    params,
  });
}

export function queryLatestAiNotice(data) {
  return request({
    url: '/ai/aiNotice/queryLatest',
    method: 'post',
    data,
  });
}

// 查询已完成房型定价报告的冻结概览，列表页不逐条补查详情。
export function queryRoomTypePricingPage(data) {
  return request({
    url: '/ai/aiNotice/queryRoomTypePricingPage',
    method: 'post',
    data,
  });
}

export function readAiNotice(data) {
  return request({
    url: '/ai/aiNotice/read',
    method: 'post',
    data,
  });
}

export function countAiNoticeUnread(params) {
  return request({
    url: '/ai/aiNotice/countUnread',
    method: 'get',
    params,
  });
}

export function readAllAiNotice(data) {
  return request({
    url: '/ai/aiNotice/readAll',
    method: 'post',
    data,
  });
}

export function submitAiNoticeFeedback(data) {
  return request({
    url: '/ai/aiNotice/feedback',
    method: 'post',
    data,
  });
}

export function getAiNoticeCategories() {
  return request({
    url: '/ai/aiNotice/categories',
    method: 'get',
  });
}

export function getAiNoticeCustomize(url) {
  var queryIndex = url.indexOf('?');
  var baseUrl = queryIndex === -1 ? url : url.substring(0, queryIndex);
  var queryString = queryIndex === -1 ? '' : url.substring(queryIndex + 1);
  var params = {};
  if (queryString) {
    queryString.split('&').forEach(function (pair) {
      var eqIndex = pair.indexOf('=');
      if (eqIndex > -1) {
        params[decodeURIComponent(pair.substring(0, eqIndex))] = decodeURIComponent(pair.substring(eqIndex + 1));
      }
    });
  }
  return request({
    url: '/ai' + baseUrl,
    method: 'get',
    params: params,
  });
}

// Only reads the latest cleaned Meituan followed-peer snapshot and never refreshes the crawler.
export function getLatestPeerHotelData(params) {
  return request({
    url: '/ai/aiDialogue/getLatestPeerHotelData',
    method: 'get',
    params,
  });
}

// Only submits a peer-hotel crawl task; the caller must not wait for crawling or cleaning to finish.
export function triggerPeerHotelCrawl(params) {
  return request({
    url: '/ai/aiDialogue/triggerPeerHotelCrawl',
    method: 'post',
    params,
  });
}

// 查询携程 hotelFavoritesSource 已清洗的最新收藏酒店 Price 快照。
export function getLatestCtripPeerHotelData(params) {
  return request({
    url: '/ai/aiDialogue/getLatestCtripPeerHotelData',
    method: 'get',
    params,
  });
}

// 向携程账号发送登录短信验证码。
export function sendCtripPeerHotelSms(data) {
  return request({
    url: '/ai/aiDialogue/sendCtripPeerHotelSms',
    method: 'post',
    data,
  });
}

// 校验携程短信验证码；验证成功后由后端继续采集收藏竞对价格。
export function verifyCtripPeerHotelSms(data) {
  return request({
    url: '/ai/aiDialogue/verifyCtripPeerHotelSms',
    method: 'post',
    data,
  });
}

export function getCtripPeerHotelLoginStatus(params) {
  return request({
    url: '/ai/aiDialogue/ctripPeerHotelLoginStatus',
    method: 'get',
    params,
  });
}

// 已登录的携程账号重新发起 hotelFavoritesSource 收藏酒店采集。
export function refreshCtripPeerHotelData(data) {
  return request({
    url: '/ai/aiDialogue/refreshCtripPeerHotelData',
    method: 'post',
    data,
  });
}

export function unbindCtripPeerHotelAccount(data) {
  return request({
    url: '/ai/aiDialogue/unbindCtripPeerHotelAccount',
    method: 'post',
    data,
  });
}

// AI 配置页读取酒店与房型价格护栏配置。
export function getAiConfigDetail(params) {
  return request({
    url: '/ai/aiConfig/detail',
    method: 'get',
    params,
  });
}

// AI 配置页仅提交酒店配置和发生变更的房型配置。
export function saveAiConfig(data) {
  return request({
    url: '/ai/aiConfig/save',
    method: 'post',
    data,
  });
}

export function getAiRevenueTraffic(params) {
  return request({
    url: '/ai/aiRevenueManager/traffic',
    method: 'get',
    params,
  });
}

export function getAiRevenueCurrentRevenue(params) {
  return request({
    url: '/ai/aiRevenueManager/currentRevenue',
    method: 'get',
    params,
  });
}

export function getAiRevenueHotelForecast(params) {
  return request({
    url: '/ai/aiRevenueManager/hotelForecast',
    method: 'get',
    params,
  });
}

export function getAiRevenueFutureRevenue(params) {
  return request({
    url: '/ai/aiRevenueManager/futureRevenue',
    method: 'get',
    params,
  });
}

export function getAiRevenueOccRevenue(params) {
  return request({
    url: '/ai/aiRevenueManager/occRevenue',
    method: 'get',
    params,
  });
}

export function getRoomTypePricingPriceAdjustmentPreview(data) {
  return request({
    url: '/ai/roomTypePricing/priceAdjustment/preview',
    method: 'post',
    data,
  });
}

export function executeRoomTypePricingPriceAdjustment(data) {
  return request({
    url: '/ai/roomTypePricing/priceAdjustment/execute',
    method: 'post',
    data,
  });
}

// 查询当前酒店 AI 用量概览及后端补齐的每日趋势。
export function getAiTokenUsageStatistics(data) {
  return request({ url: '/ai/aiTokenUsage/statistics', method: 'post', data });
}

// 分页查询 AI 调用记录，用量已由后端换算。
export function queryAiTokenUsagePage(data) {
  return request({ url: '/ai/aiTokenUsage/queryPage', method: 'post', data });
}

// 酒店知识库：分页查询当前酒店的问答，列表返回完整问题、答案和规范化标签。
export function queryHotelKnowledgePage(data) {
  return request({
    url: '/ai/hotelKnowledge/queryPage',
    method: 'post',
    // 只读分页允许并发；旧响应由页面hotelEpoch/requestId隔离，不取消新查询。
    notCheckRepeat: true,
    data,
  });
}

// 酒店知识库：查看全文和编辑前重新读取当前记录，避免使用列表中的折叠内容保存。
export function getHotelKnowledgeDetail(params) {
  return request({
    url: '/ai/hotelKnowledge/detail',
    method: 'get',
    params,
  });
}

// 酒店知识库：新增当前酒店问答，仅提交可写字段。
export function createHotelKnowledge(data) {
  return request({
    url: '/ai/hotelKnowledge/create',
    method: 'post',
    data,
  });
}

// 酒店知识库：完整替换当前酒店问答。
export function updateHotelKnowledge(data) {
  return request({
    url: '/ai/hotelKnowledge/update',
    method: 'post',
    data,
  });
}

// 酒店知识库：单条和当前页批量物理删除共用接口，ids 始终为字符串数组。
export function deleteHotelKnowledge(data) {
  return request({
    url: '/ai/hotelKnowledge/delete',
    method: 'post',
    data,
  });
}
